export const mockCart = {
    message: "Cart fetched successfully",
    cart: {
      items: [
        {
          template: {
            templateId: "67ccb8faa1e14eea07360a1b",
            name: "Template de Comercio s",
            description: "Un template profesional para una tienda online.",
            price: 99.99,
            quantity: 1,
            subtotal: 99.99
          },
          license: {
            licenseId: "67c5f84a73a5179cc6b47cb8",
            name: "Pro License",
            description: "Full access to all features, including commercial use rights.",
            price: 100.99,
            subtotal: 100.99
          },
          services: [],
          total: 200.98
        },
        {
          template: {
            templateId: "68ddc9gbb2f25ffb18471b2c",
            name: "PixlCraft",
            description: "UI Kit completo para dashboards modernos en Figma",
            price: 19.99,
            quantity: 1,
            subtotal: 19.99
          },
          license: {},
          services: [],
          total: 19.99
        },
        {
          template: {
            templateId: "67ccb8f8a1e14eea07360a19",
            name: "Template de Comercio s",
            description: "Un template profesional para una tienda online.",
            price: 99.99,
            quantity: 1,
            subtotal: 99.99
          },
          license: {
            licenseId: "67c5f84a73a5179cc6b47cb8",
            name: "Pro License",
            description: "Full access to all features, including commercial use rights.",
            price: 100.99,
            subtotal: 100.99
          },
          services: [],
          total: 200.98
        },
        {
          template: {
            templateId: "69eed9hcc3g36ggc29582c3d",
            name: "Figma UI Kit - Dashboard Pro",
            description: "Componentes reutilizables y diseño responsivo",
            price: 19.99,
            quantity: 1,
            subtotal: 19.99
          },
          license: {},
          services: [],
          total: 19.99
        },
        {
          template: {
            templateId: "70ffe0hdd4h47hhc30693d4e",
            name: "Figma UI Kit - Dashboard Pro",
            description: "Componentes reutilizables y diseño responsivo",
            price: 19.99,
            quantity: 1,
            subtotal: 19.99
          },
          license: {},
          services: [],
          total: 19.99
        }
      ],
      totalPrice: 461.93,
      status: "pending",
      createdAt: "2025-03-10T19:34:40.935Z"
    }
  };